import { z } from 'zod'

import { zProductPrice } from '@/schemas/productPriceSchema'

export const zProductsPriceResponse = z.object({
  siteId: z.string(),
  productPrices: z.array(zProductPrice),
})

export type ProductsPriceResponseSchema = z.infer<typeof zProductsPriceResponse>
